function readEnv(key: string): string | undefined {
  const value = (import.meta.env as Record<string, string | undefined>)[key];
  return value && value.length > 0 ? value : undefined;
}

export const config = {
  apiBaseUrl: readEnv('VITE_API_BASE_URL') ?? '',
  cognitoUserPoolId: readEnv('VITE_COGNITO_USER_POOL_ID') ?? '',
  cognitoClientId: readEnv('VITE_COGNITO_CLIENT_ID') ?? '',
  cognitoRegion: readEnv('VITE_COGNITO_REGION') ?? 'eu-south-1',
  cognitoHostedDomain: readEnv('VITE_COGNITO_HOSTED_DOMAIN') ?? '',
  oidcRedirectUri: readEnv('VITE_OIDC_REDIRECT_URI') ?? `${window.location.origin}/auth/callback`,
  oidcLogoutRedirectUri: readEnv('VITE_OIDC_LOGOUT_URI') ?? window.location.origin,
} as const;

export function ensureCognitoConfigured(): void {
  if (!config.cognitoUserPoolId || !config.cognitoClientId) {
    throw new Error(
      'Cognito not configured: set VITE_COGNITO_USER_POOL_ID and VITE_COGNITO_CLIENT_ID',
    );
  }
}

export function ensureHostedUiConfigured(): void {
  if (!config.cognitoHostedDomain) {
    throw new Error('Hosted UI not configured: set VITE_COGNITO_HOSTED_DOMAIN');
  }
}
